// extracted by mini-css-extract-plugin
export var optionGrid = "_bg-7";
export var optionList = "_bg-6";
export var questionsBlock = "_bg-9";
export var spacer = "_bg-5";
export var stepCenteredContent = "_bg-3";
export var stepInner = "_bg-0";
export var stepInnerFullWidth = "_bg-1";
export var stepInnerLockScroll = "_bg-2";
export var stepTransitionFrame = "_bg-4";
export var welcomeBlock = "_bg-8";